<template>
  
    <div style='max-width: 1200px;' class="my-3 text-left tag-partner">
      <!--<pre>{{ value }}</pre>-->
      <div v-if="show && value">
        <div v-if="!compact">
          <h2 class="text-center" v-if="extra">Ottieni subito la consegna gratuita!</h2>
          <h3 v-else>Il tuo abbonamento</h3>
          <p v-if="extra" class="text-center">I kit ricette e le cassette che ami, senza spese di consegna</p>
          <div v-if="extra" class="text-center">
            <img src="https://api.quomi.it/oldimg/Homepage3_v2.png" width='300'/>
          </div>
          <p :class="{'text-center': extra }" style="word-break: break-word">
              Risparmia le spese di spedizione, attiva l’abbonamento! <b>Nessun vincolo</b>, scegli tu ogni quanto ricevere i tuoi ordini.
          </p>
          <div class="flex-center flex-column my-10" v-if="thankYouPage">
              <router-link :to="{ name: 'profile_subscription'}">
                <CTA
                    :content="`Attiva l'abbonamento`"
                    isArrow
                />
              </router-link>
              <p class="center">Per beneficiare sin da subito della spedizione gratuita</p>
          </div>
          <section class="abo-section flex flex-column align-items-center" v-if="thankYouPage">
						<h2 class="text-center">Con l’abbonamento hai comodità e risparmio!</h2>
						<span class=" abo-cards flex justify-content-between">
							<div 
								v-for="(card, index) in aboCards" 							
								:key="index"
								class="flex flex-column align-items-center col-12 col-md-6"
							>
								<span>
									<v-img
										max-width="100px"
										max-height="100%"
										:src="card.src"
									/>
								</span>
								<h6 class="text-center text-bold">{{card.title}}</h6>
								<p class="text-center">{{card.text}}</p>
							</div>					
						</span>
				</section>

        </div>
        <div v-else>
          <b>Vuoi ricevere ordini periodici senza pagare le spese di consegna?</b>
          <p>
              Nessun vincolo, sospendi o attivi con un click.  Scegli tu la composizione e la frequenza. 
          </p>
        </div>
        <div>

          <span :class="{'text-center': extra }"  v-if="!thankYouPage">
            <b v-if="value.enabled && hasMin" class="qbg-primary px-1 rounded pa-1 text-body-small"><i class="fa fa-truck"></i> Nessun costo di consegna: {{ discountAmountCourier }} €  di risparmio </b>
            <b v-if="!value.enabled" class="qbg-primary px-1 rounded pa-1 text-body-small" style="display: block; width: fit-content"><i class="fa fa-truck"></i> Attiva l'abbonamento per ottenere la consegna gratuita su tutti gli ordini! </b>
          </span>
          <div class="mt-2 mb-5"> 
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <b
                  class="link-detail text-body-small"
                  v-bind="attrs"
                  v-on="on"
                >
                  Maggiori informazioni
                </b>
              </template>
              <v-card
              class="pa-3"
              max-width="900"
              tile
              >
                <div class="flex justify-content-between"  style="color: var(--quomi-primary)">
                  <h4 class="pb-3 text-bold">COMODO, FLESSIBILE E CONVENIENTE!</h4>
                  <i class="fas fa-close"></i>
                </div>

                <ul class="px-3">
                  <li class="pb-3">Consegna gratuita su tutti gli ordini</li>
                  <li class="pb-3">Nessun vincolo: l’abbonamento può essere disdetto o modificato (frequenza/composizione) in qualsiasi momento (dalla sezione profilo utente)</li>
                  <li class="pb-3">Come per gli ordini, è possibile modificare / annullare l’ordine fino alle 23 del giorno precedente alla spedizione</li>
                  <li v-if="config.lastHint">Se non effettuerai una scelta sulle ricette, ti invieremo una box con una composizione simile in base alle tue scelte passate</li>
                </ul>
              </v-card>
            </v-menu>
          </div>
        </div>
        <div class="flex" v-if="!thankYouPage" >
          <div :class="{'ma-auto text-center': config.orderNowAboCta}" v-if="loaded">
            <div class="my-5" v-if="!compact && !value.enabled && config.orderNowAboCta">
              <CTA
                  isWithLoader
                  :content="`Attiva Abbonamento`"
                  @click="changeEnabled()"
                  :disabled="loading"
                />
            </div>
            <div class="flex flex-vcenter">
              <b class="flex flex-vcenter"><span class="abo-state mr-2" style="color: var(--quomi-secondary)">Stato abbonamento:</span> &nbsp 

                <span v-if="value.enabled && hasMin" class="text-primary-color text-big">ATTIVO</span>
                <span v-else class="text-big">DISATTIVO</span>

                <v-switch
                  v-if="!showSave"
                  v-model="value.enabled"
                  class="ml-5"
                  inset
                  color="var(--quomi-green)"
                  :loading="loading"
                  @change="changeCtaStatus(false)"
                ></v-switch>
              </b>
            </div>
            <small v-if="user.recurring.enabled && this.$route.name !== 'order-now'">Data attivazione: {{$_dates_readableDate(user.recurring.time)}}</small>
            <!--<div v-if="!hasMin && !showSave">
              <span  class="text-bold" style="color: var(--quomi-orange)" >Per attivare l'abbonamento seleziona ricette o cassette per un minimo di {{ minPriceGross | priceFilter }}</span>
            </div>-->
            <div v-if="config.lastHint">Puoi ricevere in base alla frequenza scelta una box con solo Kit ricette, una o più cassette di frutta e verdura o una combinazione di kit ricette e cassette.</div><br>
            <div v-if="value.enabled || showSave">
            <div v-if="(config.recipes !== false && config.recipes !== false)" >
              <div v-if="showSave">
                <h3 class="my-5" style="margin: 0">Cosa vorresti ricevere?</h3>
                <div class="flex flex-wrap">
                  <div class="wish-recipes">
                  <div v-if="config.recipes !== false">
                    <div class="flex flex-vcenter">
                      <b class="mr-5" style="color: var(--quomi-secondary)">Ricette</b>
                      <div class="flex">
                        <v-switch
                          v-model="value.enablePlan"
                          inset
                          color="var(--quomi-green)"
                          :loading="loading"
                          @change="changeCtaStatus(false);resetEnabledIfNeeded()"
                          v-show="showSave"
                        ></v-switch>
                      </div>

                    </div>

                    <div class="flex" v-show="value.enablePlan && showSave">
                      <v-select
                        label="Ricette"
                        class="mr-5"
                        :items="recipes"    
                        v-model="value.recipes"
                        @change="filterMeals(); changeCtaStatus(false)"
                        item-text="label"  
                        item-value="value"
                        style="max-width: 140px"   
                      ></v-select>

                      <v-select
                        label="Porzioni"
                        v-if="value.recipes > 0"
                        :items="meals"    
                        v-model="value.meals"
                        @change="onChangePlan(); changeCtaStatus(false)"
                        item-text="label"  
                        item-value="value"
                        style="max-width: 140px"   
                      ></v-select>
                    </div>
                    <div class="flex flex-column" v-if="plan">
                      <span>Prezzo a porzione: <b>{{ this.value.enablePlan && this.value.recipes > 0 ? priceForPortion() : 0 | priceFilter }}</b></span>
                      <span>Prezzo Ricette : <b>{{ totalPlan | priceFilter }}</b></span>
                    </div>
                  </div>
                </div>

                <div>
                  <div v-if="config.shop !== false">
                    <div class="flex flex-vcenter" >
                      <b class="mr-5" style="color: var(--quomi-secondary)">Cassette</b>
                      <div class="flex">
                        <v-switch
                          v-model="value.enableShop"
                          inset
                          color="var(--quomi-green)"
                          :loading="loading"
                          @change="changeCtaStatus(false);resetEnabledIfNeeded()"
                        ></v-switch>
                      </div>
                    </div>

                    <div class="flex" v-show="value.enableShop && showSave">
                      <v-select
                        label="Cassette"
                        :items="shop"    
                        v-model="value.shop"
                        multiple
                        item-text="name"
                        item-value="id"
                        placeholder="Nessuna cassetta selezionata"
                        style="width: 270px"
                        @change="changeCtaStatus(false)"
                      >
                         <template v-slot:item="{ item }">
                          <v-img 
                            class="mr-3"
                            max-width="50"
                            :lazy-src="item.images.small"
                            :src="item.images.small">
                          </v-img>
                          {{item.name}}
                        </template>
                      </v-select>
                    </div>
                  </div>

                  <div v-if="config.shop !== false">
                    <div>Cassette: <b>{{ totalShop | priceFilter }}</b></div>
                  </div>
                </div>
              </div>

              <div class="mt-3">
                Prezzo consegna: 
                <b v-if="totalShipment == 0" style="color: var(--quomi-primary)" class="text-bold">GRATUITA</b> 
                <b v-else>{{totalShipment | priceFilter}}</b>
              </div>

              <div v-if="config.firstDelivery !== false" class="mt-3">
                <div class="uppercase">Totale: <b>{{ totalShop + totalPlan + totalShipment | priceFilter }}</b></div>
              </div> 
            </div>
            <div v-else>
              <h3 class="my-5" style="margin: 0">Ecco cosa riceverai</h3>
              <div class="flex flex-column" v-if="plan">
                  <span v-if="value.meals > 0 && value.recipes > 0">Ricette : <b>{{ value.recipes }}</b></span>
                  <span v-if="value.meals > 0 && value.recipes > 0">Porzioni: <b>{{ value.meals*2 }}</b></span>

                  <span v-if="value.shop.length > 0">Cassette: <br> <b v-for="item in readableShop">- {{ item }} <br></b></span>
                </div>
            </div>
          </div>
          <v-menu offset-y class="d-block pt-2" v-if="$route.name !== 'order-now'">
              <template v-slot:activator="{ on, attrs }">
                <b
                  class="link-detail text-body-small"
                  v-bind="attrs"
                  v-on="on"
                >
                  Il tuo abbonamento è SMART
                  <i class="fas fa-lightbulb pl-1"></i>
                </b>
              </template>
              <v-card
              class="px-4 py-3"
              max-width="750"
              tile
              >
                <div class="flex justify-content-end"  style="color: var(--quomi-primary)">
                  <i class="fas fa-close"></i>
                </div>
                <p>La composizione degli ordini con ricette si baserà sulle tue preferenze di acquisto (es: in passato hai ordinato solo vegetariano? Ti offriremo una selezione di ricette vegetariane!). 
                   <br>Ricorda, puoi sempre modificare il tuo ordine!
                   </p>
              </v-card>
            </v-menu>
          <h3 class="mt-5 mb-10" style="word-break: break-word" v-if="showDeliveryDate">Quando e con quale frequenza?</h3>
          <h3 class="my-5" style="margin: 0" v-else>La tua frequenza</h3>

            <div :class="{'abo-div' : config.orderNowAboCta}">
              <v-select        
                label="Consegna ogni"
                :items="frequency"                                    
                v-model="value.frequency" 
                style="max-width: 280px"   
                item-text="label"  
                item-value="value"
                @change="changeCtaStatus(false);resetCalendar()"                                                     
              ></v-select>


              <v-select
                v-show="showDeliveryDate"
                label="Giorno di consegna"
                :items="days"    
                v-model="value.day"
                item-text="label"  
                item-value="value"
                style="max-width: 280px"
                @change="changeCtaStatus(false);resetCalendar()"     
              ></v-select>
              
<!--               <div v-if="config.firstDelivery !== false && (!value.enabled || ctaDisabled  === false)">Prima data di consegna disponibile: <b>{{ nextDelivery }}</b></div> -->
              <div v-if="deliveryResolver && deliveryResolver.state.loaded" v-show="showDeliveryDate" style="max-width: 100%">
                <delivery-hours-select-basic  :resolver="deliveryResolver" v-model="timeRange" @change="changeCtaStatus(false)" style="max-width: 95%"/>
              </div>
              <div v-if="showSkippableDates">
                <h3 class="mt-10 mb-5">Le prossime date di consegna</h3>
                <div class="calendar-container mb-5">
                  <div v-for="date in getSkippableRange">
                    <div class="calendar flex flex-vcenter" :class="{'disabled': !date.active}"> 
                      <span>
                        {{ date.delivery.format("dddd DD MMMM")}} 
                      </span>
                      <CTA
                        v-if="date.skipped"
                        :content="`Riattiva`"
                        :size="`small`"
                        @click="date.active && changeCalendar(date, false)"
                      />
                      <CTA
                        v-else
                        :content="`Salta`"
                        :size="`small`"
                        @click="date.active && changeCalendar(date, true)"
                      />

                      <span v-if="!date.active">
                        Consegna non disponibile
                      </span>
                    </div>
                  </div>
                  <p v-if="value.enabled && calendarFlash" style="color: var(--quomi-orange)" class="pt-5 text-bold">Clicca su "salva modifiche" per confermare la tua scelta</p>
                </div>
              </div>
              <div>
                <div v-if="showSave">
                  <div v-if="(value.enablePlan && value.recipes > 0) || (value.enableShop && value.shop.length > 0)">
                    <CTA
                    class="mt-10"
                      v-if="!compact && !value.enabled && !config.orderNowAboCta"
                      isWithLoader
                      :content="`Attiva Abbonamento`"
                      @click="changeEnabled()"
                      :disabled="loading || !hasMin && showSave"
                    />
                    <CTA
                      v-if="!compact && value.enabled"
                      isWithLoader
                      :content="`Salva modifiche`"
                      @click="changeSubscription(); changeCtaStatus(true)"
                      :disabled="ctaDisabled || !hasMin && showSave"
                      class="mt-5"
                    />    
                    <p  class="mt-5 mb-2" style="word-break: break-word" v-if="!compact && value.enabled">Sospendendo l'abbonamento, <b>perderai la consegna gratuita</b> su tutti i tuoi ordini.</p> 
                  </div>
                  <div v-else>
                    E' necessario selezionare almeno una delle opzioni per salvare la modifica.
                  </div>
                </div>
              </div>
              <div v-if="!hasMin && showSave">
               <span  class="text-bold" style="color: var(--quomi-orange); font-size: 14px" >Per attivare l'abbonamento seleziona ricette o cassette per un minimo di {{ minPriceGross | priceFilter }}</span>
                <p class="mt-5 mb-2" v-if="value.enablePlan === false && value.enableShop === false">Sospendendo l'abbonamento, <b>perderai la consegna gratuita</b> su tutti i tuoi ordini.</p>
              </div>
            </div>
              <v-btn
                    depressed
                    color="var(--quomi-orange)"
                    v-if="value.enabled && showSave"
                    type="button" 
                    style="color: white; margin: 5px 0 10px 0" 
                    @click="changeEnabled(); resetPlan()">Sospendi abbonamento
              </v-btn>

              <div style="word-break: break-word">
                Potrai modificare le impostazioni in qualsiasi momento dal tuo profilo utente
              </div>
              <flash
                v-if="showSave"
                :flash="flash"
                :state="state"
                class="mr-5 mt-5"
              />
            </div>

          </div>
        </div>  
      </div>
      <div v-else>
        Ricordati che hai un abbonamento attivo. Per disattivarlo vai nella sezione <router-link :to="{name: 'profile_subscription'}" class="link-detail">abbonamento</router-link> del tuo profilo
      </div>
    </div>
</template>

<script type="text/javascript">

import { configStore } from '../../store/configStore' 
import { UserApi } from '../../api/UserApi'
import { ExtraApi } from '../../api/ExtraApi'
const moment = require('moment')
import Flash from '../Parts/Flash'
import { plansStore } from '../../store/plansStore'
import { deliveryStore } from '../../store/deliveryStore'
import { deliveryContainer } from '../../mixins/deliveryContainer'
import { orderStore } from '../../store/orderStore'
import { Order } from '../../core/Order'
import { DeliveryApi } from '../../api/DeliveryApi'
import {DeliveryManager} from '../../core/delivery/DeliveryManager'
import DeliveryHoursSelectBasic from '../Delivery/DeliveryHoursSelectBasic'
import { subscriptionStore } from '../../store/subscriptionStore'
import { recurring } from "../../mixins/recurring"
import { RecurringHelper } from '../../services/RecurringHelper'

export default {
  components: {
    Flash,
    DeliveryHoursSelectBasic
  },
  props: {
    compact: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default () {
        return {
          calendar: [],
          shop: true,
          recipes: true,
          firstDelivery: true,
          totalPrice: false,
          type: 'normal',
          lastHint: false,
          orderNowAboCta: false
        }
      }
    },
    extra: {
      type: Boolean,
      default: false
    },
    thankYouPage: {
      type: Boolean,
      default: false
    },
    showSkippableDates: {
      type: Boolean,
      default: true
    },
    showSave: {
      type: Boolean,
      default: true
    },
    showDeliveryDate: {
      type: Boolean,
      default: true
    },
    defaultEnabled: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    deliveryContainer,
    recurring
  ],
	data () { //update all custom data using config admin
		return {
      shipmentZone: null,
      loaded: false,
      plansStore: plansStore.state,
      orderStore: orderStore.state,
      deliveryStore: deliveryStore.state,
      subscriptionStore: subscriptionStore.state,
      value: false,
      loading: false,
      show: true,
      frequency: [
        {value: 7, label: "settimana"},
        {value: 14, label: "2 settimane"},
        {value: 28, label: "4 settimane"}
      ],
      meals: [],
      recipes: [],
      products: [],
      shop: [],
      plan: [],
      default: {
        enabled: 0,
        frequency: 7,
        meals: 1,
        day: 1,
        recipes: 0,
        shop:[],
        enablePlan: true,
        enableShop: false
      },
      flash: null,
      calendarFlash: false,
      state: null,
      configStore: configStore.state,
      aboCards: [
				{
					title: "Personalizza la tua box",
					text: "Scegli la composizione base della tua box. Puoi modificarla in qualsiasi momento.",
					src: "https://api.quomi.it/oldimg/ICONA_1-%282%29.png"
				},
				{
					title: "Scegli la frequenza",
					text: "Imposta la frequenza e il giorno di consegna. Puoi sospenderti con un click, senza vincoli, quando vuoi.",
					src: "https://api.quomi.it/oldimg/ICONA_2-%281%29.png"
				},
				{
					title: "Consegna sempre gratuita",
					text: "Con l'opzione in abbonamento avrai sempre la consegna gratuita su tutti i tuoi ordini!",
					src: "https://api.quomi.it/oldimg/ICONA_3-%281%29.png"
				}
			],
      ctaDisabled: true,
      timeRange: {
        start: null,
        end: null
      },
      deliveryResolver: null,
		}
	},
  computed: {
    readableShop() {
      return this.value.shop.map(i => {
        return this.shop.find(p => i == p.id)
      }).map(i => {
        return i.name;
      })
    },
    delivery () {
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },
    totalPlan () {
      return new RecurringHelper().getTotalPlan(this.value, this.plan);
    },
    totalShipment () {
      if (!this.deliveryResolver) {
        return 0;
      }

      return this.deliveryResolver.getPriceRange(this.timeRange.start, this.timeRange.end)
    },
    minPriceGross() {
      return new RecurringHelper().getMinPriceGross();
    },
    hasMin() {

      /* if(this.$route.name === 'order-now') {
        return 0
      } */

      return new RecurringHelper().hasRecurringReachedMin(this.value, this.products, this.plan);
    },
    totalShop () {
      return new RecurringHelper().getTotalShop(this.value, this.products);
    },
    nextDelivery() {

      let delta = this.getDelta();
      let day = this.value.day - 1;

      let now = moment()

      let minimum = moment(now).locale('it').add(6, 'days')
      let next = moment(now).locale('it').startOf('week').add(day == 0 ? 7 : day,'days');

      while (next.format() < minimum.format()) {
        next = next.add(1, 'weeks');
      }

      return next.add(delta+1, 'days').locale('it').format('dddd D MMMM')
    },
    days() {
        let x = this.getDelta();
        
        let date = moment().locale('it').startOf('week');

        let arr = [
          {value: 1, label: this.getDay(date,1+x)},
          {value: 2, label: this.getDay(date,2+x)},
          {value: 3, label: this.getDay(date,3+x)},
        ];


        /* if (x < 1) {
          let dayToRemove = 'giovedì'

          arr = arr.filter(item => {
              return item.label !== dayToRemove
          })

          arr.push(
            {value: 4, label: this.getDay(date,4+x)}
          )
        } else {
          let dayToRemove = 'venerdì'

          arr = arr.filter(item => {
              return item.label !== dayToRemove
          })
        } */

        return arr;

    },
    user() {
      return this.$root.user
    },
    order() {
      return this.user ? this.user.order : null;
    },
    discountAmountCourier () {
      return this.configStore.config && this.configStore.config['quomi.sources.default.subscription_courier_discount']
        ? this.configStore.config['quomi.sources.default.subscription_courier_discount']
        : 0
    }
  },
  methods: {
    resetCalendar() {
      this.value.calendar = [];
    },
    changeCalendar(date, value) {
      this.showCalendarFlash()

      let shipment = date.shipment.format("YYYY-MM-DD")
      let index = this.value.calendar.indexOf(shipment);

      if (value && index == -1) {
        this.value.calendar.push(shipment)
      }

      if (!value && index != -1) {
        this.value.calendar.splice(index, 1)
      }

      this.changeCtaStatus(false)
    },
 
    updateTimeRange(value) {
      this.timeRange = value
    },
    getDelta() {
      let s = this.user.subscription.shipment_zone;
      return s && s.transit_time > 24 ? 1 : 0
    },
    getDay(val,day) {
      return moment(val).locale('it').weekday(day).format('dddd')
    },
    changeSubscription() {
      this.changeValue()
    },
    loadShop() {
      let helper = new RecurringHelper();

      return helper.retrieveInfoAboutItemsShop().then(products => {
        this.products = products;
        this.shop = products;
      })
     
    },
    loadPlan() {
      let helper = new RecurringHelper();

      try {
        return helper.retrieveInfoAboutPlan(this.value).then(i => {
          this.plan = i
        })
      } catch (e) {
        if (e.message != 'invalid meals quantity') {
          throw e
        }
        this.plan = null;
      }
    },
    changeEnabled() {
      this.value.enabled = !this.value.enabled
      this.updateEnabled()
    },

    /**
     * This function will help to avoid changing the current value
     * when suspending/reactivating the subscription but forcing
     * to populate if there is no current value. For example
     * a new value could be added but the subscription is already
     * activated
     */
    updateValueIfNotAlready(param, value) {
      if (!this.value[param] || !this.value.referenceOrderId) {
        this.value[param] = value;
      }
    },

    updateEnabled() {
      this.$emit('hide-paragraph', this.value.enabled)
      return Promise.resolve(1).then(() => {    
        return this.loadOrders()
      }).then(() => {
      let order = this.lastOrder
      if (order) {
        if(!this.value.referenceOrderId ||!this.value.lastOrderId) {
          this.value.referenceOrderId = order.id;
          this.value.lastOrderId = order.id;
          this.value.recipes = order.plan.meals > 0 ? order.plan.meals : this.value.recipes
          let lastShop =  order.extras.filter(p => { 
          return this.shop.find(s => s.id == p.id)
          }).map(i => {
              return i.id
          })
          this.value.shop = lastShop && lastShop.length > 0 ? lastShop : this.value.shop
        }

        this.value.meals = 1;


        this.updateValueIfNotAlready('day', this.delivery ? this.delivery.shipment_day : order.shipment_day);
        
        this.value.time = new Date()
       
        this.value.enablePlan = this.value.recipes > 0 ? 1 : 0
        this.value.enableShop = this.value.shop.length > 0 ? 1 : 0
        this.value.timeRange = this.timeRange;

        if (!this.value.enablePlan && !this.value.enableShop) {
          this.value.enabled = false;
        }

        this.onChangePlan();
      }
      this.changeValue()
      })
    },

    showFlash (params) {
      this.flash = params.flash
      this.state = params.state

      setTimeout(() => {
        this.flash = null
      }, 3000)
    },

    showCalendarFlash (params) {
      this.calendarFlash = true

      setTimeout(() => {
        this.calendarFlash = false
      }, 3000)
    },


    changeValue() {
      this.loading = true;
      
      this.value.timeRange = this.timeRange;
      var um = new UserApi()

      let value = JSON.parse(JSON.stringify(this.value));
      value.shop = value.shop.map(i => {
        return {id:i,qty:1} 
      })

      um.changeRecurring({recurring: JSON.stringify(value)}).then(response => {
      }).then(response => {
        this.user.recurring = this.value;
        this.loading = false;

        window.dispatchEvent(new CustomEvent('recurring-updated', { 
          bubbles: true, 
          detail: value 
        }));
        this.showFlash({
          flash: '<i class="fas fa-check"></i> Le tue modifiche sono state salvate e si applicheranno  ai prossimi ordini periodici',
          state: 'success'  
        })
      })
    },

    filterMeals() {
      for(let i = 1; i <= 18; i++) {
        this.meals.push({value: i, label: `${i*2} porzioni`})
      }
      this.meals = this.meals.filter(el => (el.value*2) * this.value.recipes <= 36)
      this.loadPlan()
    },

    onChangePlan(){
      this.loadingApi = true;
      return this.loadPlan().then(i => {
        this.loadingApi = false;
      })
    },
     priceForPortion () {
      return +(this.plan.price / this.plan.meals / this.plan.people).toFixed(2)
    },

    changeCtaStatus(param) {

      return this.ctaDisabled = param
    },

    resetEnabledIfNeeded() {
      if (this.showSave) {
        return;
      }

      this.value.enabled = this.value.enablePlan || this.value.enableShop;
    },

    loadOrders () {
			var um = new UserApi()
			return um.orders({
				show: 1,
				sort: '-created_at',
				query: 'status != "canceled" and ((status = "pending" and recurring = 1) or status != "pending" or (status = "pending" and confirmed_at is not null and ok = 1))'
			}).then(response => {
        let order = response.body.resources[0]
			  this.lastOrder = new Order(order ? order : orderStore.state.order)  
			})
		},

    resetPlan() {
      if(this.value.recipes > 0) {
        this.value.recipes = 0
      }
      if(this.value.shop.length > 0 && this.$route.name !== 'order-now') {
        this.value.shop = []
      }
    }

  },
  mounted() {

    let meals = []
    this.loaded = false;

    for(let i = 1; i < 18; i++) {
      this.meals.push({value: i, label: `${i*2} porzioni`})
    }

    let recipes = []

    this.recipes.push({value: 0, label: "0 ricette"})
    this.recipes.push({value: 1, label: "1 ricetta"})

    for(let i = 1; i < 8; i++) {
      this.recipes.push({value: i, label: `${i} ricette`})
    }

    //this.meals = meals

    this.value = this.default
    this.value.enabled = this.defaultEnabled
    let api = new UserApi();

    this.loadSkippable().then(i => {
      return this.loadShop()
    }).then(i => {
      return api.getRecurring()
    }).then(response => {
      let recurring = response.body.data.resource
      try {
        if (recurring && this.user.subscription.status !== 'pending') {
          let val = JSON.parse(recurring);
          val.shop = val.shop.map(i => {
            return i.id
          });
          this.value = val
          return Promise.resolve(1)
        } else if(this.defaultEnabled) {
          return this.updateEnabled()
        }
      } catch (e) {
        this.value = this.default
      }
    }).then(i => {

      if (this.compact && this.value !== false && this.value.enabled == true) {
        this.show = false
      }


      if (typeof this.value !== "object") {
        this.value = this.default
      }

      if (this.value.timeRange) {
        this.timeRange = this.value.timeRange 
      }

      return this.onChangePlan()
    }).then(i => {

        return this.$_deliveryContainer_loadSubscriptionDelivery().then(response => {
          try {
            let courier = response.body.included.find(record => record.type === 'courier')
            subscriptionStore.updateShipmentCourier(courier.attributes.name)

            this.deliveryResolver = new DeliveryManager().getResolverByName(this.subscriptionStore.shipment_type)

            let address = response.body.included.find(record => record.type === 'address')

            this.shipmentZone = response.body.included.find(record => record.type === 'shipment-zone')
            this.deliveryResolver.loadBySubscription(address.attributes.zip_code, address.attributes.city);
          } catch (e) {
            console.log(e)
          }
        })
    }).then(i => {

      if (!this.value.calendar) {
        this.value.calendar = [];
      }
      this.loaded = true;

      if (!this.showSave && this.$route.name == 'subscription-step' && !this.hasMin) {
          this.$router.push({name: 'verify-page'})
      }

    })
  },
  destroyed() {

    window.removeEventListener('verify-page-confirmed', this.listener);
    window.removeEventListener('subscription-confirmed', this.listenerSubscriptionConfirmed);
  },
  created() {


    this.listener = (e) => {
      this.changeSubscription()
    }
    this.listenerSubscriptionConfirmed = (e) => {
      this.changeSubscription()
    }

    window.addEventListener('verify-page-confirmed', this.listener);
    window.addEventListener('subscription-confirmed', this.listenerSubscriptionConfirmed);
  }
}
</script>

<style scoped>
.calendar {
  max-width: 90%;
}
.disabled {
  opacity: 0.5;
}
.abo-div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wish-recipes {
  margin-right: 50px;
}

@media(max-width: 376px) {
		.wish-recipes {
      margin-right: 0;
    }
    
    .calendar > * {
      font-size: 14px;
    }

    .abo-state {
      font-size: 14px;
    }
}

@media(max-width: 768px) {
		.abo-cards {
			flex-direction: column;
		}
}
</style>

<style>
.v-select__selection.v-select__selection--comma {
  font-size: 14px !important;
}
 .v-menu__content::-webkit-scrollbar {
   width: 10px;
   background: white;
}
.v-menu__content::-webkit-scrollbar-track {
  background: var(--quomi-primary);
    border: 4px solid transparent;
    background-clip: content-box; 
}

.v-menu__content::-webkit-scrollbar-thumb {
  background: var(--quomi-primary);
  background-clip: content-box; 
  border-radius: 15px;
  border-right: 10px;
  width: 10px !important;
} 


@media(max-width: 768px) {
		.v-list-item__action{ 
      margin-right: 15px !important;
    }

    .v-list-item__title{ 
      white-space: unset !important;
    }
}

.calendar > span {
  width: 200px;
}

.calendar > * {
  margin: 15px 15px 15px 0;
}
</style>